import PropTypes from 'prop-types';
import NumberInput from '@components/input/number.input.jsx';
import NumberSliderInput from '@components/input/number-slider.input.jsx';
import { useRulesetModifiers } from './donation-train-overlay.hooks.js';
import { useCallback } from 'preact/hooks';

DonationTrainOverlayRuleset.propTypes = {
  ruleset: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default function DonationTrainOverlayRuleset({
  ruleset,
  onSave,
  onReset,
}) {
  const {
    handleMinChange,
    handleCountChange,
    handleTimerChange,
    donationsCountMin,
    donationValueMin,
    contentChanged,
    timer,
    isNew,
  } = useRulesetModifiers(ruleset);

  const handleOnSave = useCallback(() => {
    onSave({
      ...ruleset,
      donationValueMin,
      donationsCountMin,
      timer,
    });
  }, [ruleset, onSave, donationValueMin, donationsCountMin, timer]);

  return (
    <>
      <NumberInput
        onChange={handleTimerChange}
        value={timer}
        minValue={1}
        maxValue={59}
        labelText="Timer"
        isCurrency={false}
        description={
          <>
            Amount of <b>time</b> allowed for another donation to extend the
            train
          </>
        }
        suffix={
          <span className="w-24 text-right">
            minute{timer === 1 ? '' : 's'}
          </span>
        }
        inputClassName="w-full"
      />

      <NumberInput
        onChange={handleMinChange}
        value={donationValueMin}
        minValue={0}
        maxValue={500}
        labelText="Minimum Donation Amount"
        isCurrency={true}
        description={
          <>
            The minimum donation <b>amount</b> required to start a train
          </>
        }
        inputClassName="w-full"
      />

      <NumberSliderInput
        labelText="Donation Count"
        fieldName="donationsCountMin"
        onChange={handleCountChange}
        value={donationsCountMin}
        minValue={1}
        maxValue={10}
        inputClassName="w-full"
        description={
          <>
            The minimum <b>count</b> of donations required to start a train
          </>
        }
      />

      <div className="flex justify-between items-center w-full">
        <button
          className="btn btn-accent btn-sm"
          onClick={() => onReset(ruleset)}
          disabled={isNew}
        >
          Reset
        </button>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => handleOnSave()}
          disabled={!contentChanged}
        >
          Save
        </button>
      </div>
    </>
  );
}
